<template>
    <div id="art-works">
        <div class="heading">
        Art works
        </div>
        <p class="para">A collection of some of my art and graphic design works</p>
        <div class="gallery">
            <div class="gallery-item" v-for="(art, index) in paintings" :key="index" @click="openModal(art)">
                <img :src="art.src" :alt="art.name" class="thumbnail" />
                <p style="margin-top: 16px; margin-bottom: 6px;">{{art.name}}</p>
            </div>
            <div class="gallery-item" v-for="(art, index) in graphicdesign" :key="index" @click="openModal(art)">
                <img :src="art.src" :alt="art.name" class="thumbnail" />
                <p style="margin-top: 16px; margin-bottom: 6px;">{{art.name}}</p>
            </div>
        </div>

        <!-- Fullscreen Modal -->
        <div v-if="selectedArt" class="modal" @click="closeModal">
            <div class="modal-content" @click.stop>
                <img :src="selectedArt.src" :alt="selectedArt.name" class="full-image" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ArtWorks',
    data() {
        return {
            selectedArt: null,
            paintings: [
                { name: 'A Gorgeous Sunset / Acrylic / 2026', src: require('@/assets/artworks/theGorgeousSunset.jpg') },    
                { name: 'Paradise Lost / Acrylic / 2025', src: require('@/assets/artworks/paradiseLost.jpg') },
                { name: 'My First Acrylic / Acrylic / 2024', src: require('@/assets/artworks/firstAcrylic.jpg') },
                { name: 'Splashing Lighthouse / Watercolor / 2016', src: require('@/assets/artworks/theSplashingLighthouse.jpg') },
                { name: 'Eru Thazhuvudhal / Watercolor', src: require('@/assets/artworks/bull_art.jpg') },    
                { name: 'Aandal / Watercolor', src: require('@/assets/artworks/aandal_art.jpg') },
                { name: 'Parrot / Watercolor', src: require('@/assets/artworks/parrot_art.jpg') },
                { name: 'Rajasthan / Watercolor', src: require('@/assets/artworks/rajasthan_art.jpg') },
            ],
            graphicdesign: [
                { name: 'Coding Hungama / Poster', src: require('@/assets/artworks/hungama.jpg') },
                { name: 'K-Idol / Poster', src: require('@/assets/artworks/kidol.jpg') },
                { name: 'Sync / Invitation', src: require('@/assets/artworks/invitation_model_2.jpg') },
                { name: 'K! Cover / Brochure', src: require('@/assets/artworks/ir-brochure-frontpage.jpg') },
                { name: 'K! Pages / Brochure', src: require('@/assets/artworks/brochure_pages.jpg') },
                { name: 'Tedx / Notebook Cover', src: require('@/assets/artworks/note-cover.png') },
                { name: 'CEG Tech Forum / Logo', src: require('@/assets/artworks/ctf-logo.png') },
                { name: 'Sparks / Logo', src: require('@/assets/artworks/sparks-logo-new1.jpg') },
                { name: 'Dexterbot / Mascot', src: require('@/assets/artworks/thumbsup-profile-pic-copy.jpg') },
                { name: 'Windows Phone reimagined / UI', src: require('@/assets/artworks/windows_ui.jpg') },
            ]

        }
    },
    methods: {
        openModal(art) {
            this.selectedArt = art;
        },
        closeModal() {
            this.selectedArt = null;
        }
    }
}
</script>

<style scoped>
.gallery {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
    margin-top: 30px;
}
.gallery-item {
    cursor: pointer;
    transition: transform 0.2s ease-in-out;
}
.gallery-item:hover {
    transform: scale(1.05);
}
.thumbnail {
    width: 100%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    margin: 0;
    display: block;
    background-color: var(--hover-bg);
}

/* Modal Styles */
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: var(--modal-bg);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}
.modal-content {
    max-width: 90%;
    max-height: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.full-image {
    max-width: 100%;
    max-height: 90vh;
    object-fit: contain;
    border-radius: 12px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
    background-color: #1a1a1a;
}

@media screen and (max-width: 1024px) {
    .gallery {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media screen and (max-width: 768px) {
    .gallery {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media screen and (max-width: 480px) {
    .gallery {
        grid-template-columns: repeat(1, 1fr);
    }
}
</style>